import { render, staticRenderFns } from "./SpeechBubbleMenu.vue?vue&type=template&id=433321fa&scoped=true&"
import script from "./SpeechBubbleMenu.vue?vue&type=script&lang=ts&"
export * from "./SpeechBubbleMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechBubbleMenu.vue?vue&type=style&index=0&id=433321fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433321fa",
  null
  
)

export default component.exports